const services = [
  {
    title: "Partnership Sales",
    copy: "Representing selected sporting properties and identifying brands capable of becoming meaningful long-term partners.",
    testid: "service-sales",
  },
  {
    title: "Brand Partnerships",
    copy: "Helping brands identify suitable opportunities across Formula One, football and international sport.",
    testid: "service-brand",
  },
  {
    title: "Rights & Sponsorship",
    copy: "Supporting commercial rights packages from initial positioning through to partner discussions.",
    testid: "service-rights",
  },
  {
    title: "Introductions",
    copy: "Connecting brands, teams, clubs and decision-makers where there is genuine strategic alignment.",
    testid: "service-introductions",
  },
  {
    title: "Experiences",
    copy: "Using hospitality, events and live sport to strengthen commercial relationships.",
    testid: "service-experiences",
  },
];

export default function ServicesGrid() {
  return (
    <section id="services" className="bg-[#0A0A0A] border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-28 lg:py-36">
        <p className="font-mono-tech text-[11px] uppercase tracking-[0.3em] text-[#F7F6F2] mb-6">
          03 — Services
        </p>
        <h2 className="font-heading font-light uppercase tracking-tight leading-[1.05] text-4xl sm:text-5xl lg:text-6xl mb-16">
          What We Do
        </h2>

        <div className="border-t border-white/10">
          {services.map((s, i) => (
            <div
              key={s.title}
              data-testid={s.testid}
              className="group grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-8 items-baseline py-10 border-b border-white/10 hover:bg-[#111111] transition-colors duration-200 px-2 md:px-4"
            >
              <span className="md:col-span-1 font-mono-tech text-xs text-[#F7F6F2] tracking-[0.2em]">
                {String(i + 1).padStart(2, "0")}
              </span>
              <h3 className="md:col-span-4 font-heading font-medium text-2xl tracking-tight group-hover:text-[#F7F6F2] transition-colors duration-200">
                {s.title}
              </h3>
              <p className="md:col-span-7 text-sm sm:text-base text-neutral-400 font-light leading-relaxed max-w-2xl">
                {s.copy}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
